import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Title } from 'components/misc'
import { MusicLinks } from 'components/music-links'
import { Section } from 'components/misc'

export const Musicians = forwardRef<HTMLDivElement, {}>((_, ref) => (
  <Section ref={ref}>
    <TextContainer>
      <Title data-menu-title="современная музыка">Современные музыканты</Title>
      <p>
        Сегодня музыка в республике создается на фундаменте
        музыкально-поэтического эпоса, в результате чего рождаются особенный
        стиль и манера исполнения. Многие музыканты в своем творчестве смешивают
        национальный фольклор и современные музыкальные жанры. Чтобы еще больше
        подсветить культуру Бурятии и ее идентичность, некоторые исполнители
        поют песни исключительно на бурятском языке. Мы собрали подборку самых
        ярких музыкантов современной Бурятии:
      </p>
    </TextContainer>

    <MusicLinks link="https://music.youtube.com/playlist?list=PL2LCM5HET2HbS9JCh0ur857LR2-XLmTEg&si=0KPVXGT-VdzJGokN">
      <span>слушать </span> в YT Music
    </MusicLinks>
  </Section>
))
